import * as actionTypes from '../../constants/actionTypes'
import splitRoomname from '../../../lib/splitRoomname'
import splitParams from '../../../lib/splitParams'
import getInputDeviceList from '../../../lib/getInputDeviceList'
import usernameLib from '../../../lib/username'
import { setupTypes } from './setupTypes'
import { ReduxAction, State } from '../../reducers/reducerType'
import { trackType } from '../tracks'
import { setFeatureFlag } from '../ui/uiActions'
import Logger from '@bt-react/libs/Logger'
import storage from '../../../lib/storage'
import { addRemoteParticipants, participantConnected } from '../room/room'
import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import { Room } from 'twilio-video'
import { mediaType as MediaType } from '@bt-react/constants'
import roomDefaultState from '../../reducers/room/defaultState'
import { setLocalBridge } from '../gig/gigActions'
import apiGateway from '../../../services/apiGateway/apiGateway'
import { addEntry } from '../../../lib/audit'
import docUpdateAndLog from '../../../lib/docUpdateAndLog'


export const setHost = host => ({ type: actionTypes.SET_HOST, payload: host })

export const setChannelAndWebcast = roomname => dispatch => {

  const parsedRoomname = splitRoomname(roomname)

  if (!parsedRoomname) return dispatch({ type: 'SET_CHANNEL_AND_WEBCAST_ERROR' })

  const { channelId, webcastId } = parsedRoomname

  dispatch({ type: actionTypes.SET_CHANNEL_AND_WEBCAST, payload: { channelId, webcastId } })

}

export const setRoomname = roomname => dispatch => {

  dispatch({ type: actionTypes.SET_ROOMNAME, payload: roomname })
  dispatch(setChannelAndWebcast(roomname))

}

export const setUser = username => ({ type: actionTypes.SET_USER, payload: username })

export const setRole = userRole => async (dispatch, getState: () => State) => {

  const { BTID } = getState().user
  const roleUsername = usernameLib.getUsername(userRole, BTID || '')

  await dispatch(setUser(roleUsername))

  dispatch({ type: actionTypes.SET_ROLE, payload: { role: userRole, username: roleUsername } })

}

export const joinRoom = () => ({ type: actionTypes.JOIN_ROOM })

export const fetchToken = (communicationId, username, options = {}) => (dispatch, getState) => {

  const { roomname } = getState().config
  const params = splitParams(document.location.search)
  username = username || getState().config.username

  if (!communicationId) communicationId = roomname

  return dispatch({ type: actionTypes.TOKEN_FETCH, payload: { communicationId, tokenName: username, options: params } })

}
export const fetchTokenSuccess = (token) => ({ type: actionTypes.TOKEN_SUCCESS, payload: token })
export const fetchTokenError = (error) => ({ type: actionTypes.TOKEN_ERROR, payload: error })
export const setUIDocumentStateComplete = () => ({ type: actionTypes.SET_UI_DOCUMENT_STATE_COMPLETE })
export const setBackendDocumentStateComplete = () => ({ type: actionTypes.SET_BOOKING_DOCUMENT_STATE_COMPLETE })
export const setRoom = (room: Room) => dispatch => {

  dispatch({ type: setupTypes.SET_ROOM, payload: room })
  dispatch(participantConnected(get(room, 'localParticipant.sid'), get(room, 'localParticipant.identity')))
  dispatch(addRemoteParticipants(get(room, 'participants')))

}
export const setRoomError = () => ({ type: setupTypes.SET_ROOM_ERROR })
export const setAvailableDevices = () => async (dispatch, getState: () => State) => {

  const devices = await getInputDeviceList()
  const { inputDevices } = getState().config
  const { presenterBackground } = getState().userSettings
  const { selectedAudioDeviceID, selectedVideoDeviceID } = getState().tracks

  if (isEqual(devices, inputDevices)) return

  dispatch({ type: actionTypes.SET_AVAILABLE_DEVICES, payload: devices })

  let video = ''
  let audio = ''

  for (const [deviceId, { kind }] of devices) {
    //Below code will check if the already selected device is valid or not and set it to the video or audio
    if (kind === 'video' && (deviceId === storage.getItem('alreadySelectedVideoDevice'))) {
      video = deviceId
    }

    if (kind === 'audio' && (deviceId === storage.getItem('alreadySelectedAudioDevice'))) {
      audio = deviceId
    }

  }

  for (const [deviceId, { kind }] of devices) {

    if (deviceId === 'default' || deviceId === 'communications') continue

    if (kind === 'video' && video === '') {

      video = deviceId

    }

    if (kind === 'audio' && audio === '') {

      audio = deviceId

    }

    if (video !== '' && audio !== '') break

  }

  if (!devices.has(selectedAudioDeviceID) && selectedAudioDeviceID !== audio) {

    dispatch({ type: trackType.SET_SELECTED_AUDIO_DEVICE, payload: audio })
    storage.setItem('alreadySelectedAudioDevice', audio)

  }
  
  if (!devices.has(selectedVideoDeviceID) && selectedVideoDeviceID !== video) {

    dispatch({ type: trackType.SET_SELECTED_VIDEO_DEVICE, payload: { selectedDevice: video, background: presenterBackground }})
    storage.setItem('alreadySelectedVideoDevice', video)

  }

}
export const storeFeatureFlagState = (feature, value) => (dispatch) => {

  const currentEnabledFlags: string[][] = storage.getItem('talks-features') || []
  const newEnabledFlags: string[][] = currentEnabledFlags
    .filter(([_feature]) => _feature !== feature)
    .concat([[feature, value]])

  storage.setItem('talks-features', newEnabledFlags)
  dispatch(setFeatureFlag(feature, value))

}
export const setFeatureFlagsState = () => (dispatch) => {

  const currentEnabledFlags: string[][] = storage.getItem('talks-features') || []

  for (const [feature, value] of currentEnabledFlags) {

    dispatch(setFeatureFlag(feature, value))

  }

}

export const setAvailableFeaturesOnSetup = () => async (dispatch, getState) => {

  const { config: { channelId }, user } = getState()
  const userName = user.data?.firstName + ' ' + user.data?.lastName

  addEntry('PresenterService', 'GetAvailableFeatures', `${userName || user.BTID} is getting the available features`)

  try {

    const featuresObj = (await apiGateway.getAvailableFeatures(channelId)).data.features
    addEntry('PresenterService', 'GetAvailableFeatures', `${userName || user.BTID} call to get available features was successful`)

    return dispatch(({ type: setupTypes.SET_AVAILABLE_FEATURES, payload: featuresObj }))

  } catch (e) {

    console.log('Error fetching enabled features: ', e)
    addEntry('PresenterService', 'GetAvailableFeatures', `${userName || user.BTID} call to get available features was unsuccessful. Error: ${e}`)
    return

  }


}

export const setGigOptions = () => (dispatch) => {

  const split = splitParams(window.location.search)

  if (split.debug) {

    dispatch(setDebug())
    dispatch(setFeatureFlagsState())
    Logger.enabled(split.debug)

  }

  if (split.localBridge) {
    dispatch(setLocalBridge(true))
  }

  if (split.serviced) {
    dispatch(setServicedOption())
  }

  return dispatch({ type: setupTypes.SET_GIG_OPTIONS, payload: split })

}
export const setBridgeName = (bridgeName: string): ReduxAction<string> => ({ type: setupTypes.SET_BRIDGE_NAME, payload: bridgeName })
export const setActiveBridge = (bridgeName: string): ReduxAction<string> => ({ type: setupTypes.SET_ACTIVE_BRIDGE, payload: bridgeName })
export const docBridgeDataListenersAdded = () => ({ type: setupTypes.DOCUMENT_BRIDGE_DATA_LISTENERS_ADDED })
export const setPresenterTracks = () => ({ type: setupTypes.SET_PRESENTER_TRACKS })
export const setServicedOption = () => ({ type: setupTypes.SET_SERVICED_OPTION, payload: true })
export const fetchCanUserPresent = (webcastId: string) => async (dispatch) => {
  try {
    await apiGateway.getCanUserPresent(webcastId)
    dispatch({ type: setupTypes.SET_CAN_USER_PRESENT, payload: true })
  } catch (e) {
    dispatch({ type: setupTypes.SET_CAN_USER_PRESENT, payload: false })
  }
}
export const fetchDoesUserHaveRoles = () => async (dispatch) => {
  try {
    const res = await apiGateway.getCheckUserHasRoles()
    if (res.data?.roles) {
      dispatch({ type: setupTypes.SET_USER_HAS_CHANNEL_ROLES, payload: true })
    } else {
      dispatch({ type: setupTypes.SET_USER_HAS_CHANNEL_ROLES, payload: false })
    }
  } catch (e) {
    dispatch({ type: setupTypes.SET_USER_HAS_CHANNEL_ROLES, payload: false })
  }
}
export const setWebcam = () => async (dispatch, getState) => {

  const { docs: { uiDoc } } = getState()

  await docUpdateAndLog(uiDoc, { mediaType: MediaType.WEBCAM, focusOn: roomDefaultState.focusOn }, 'uiDoc')

}
export const setDebug = () => ({ type: setupTypes.SET_DEBUG })

export default {
  docBridgeDataListenersAdded,
  fetchToken,
  setActiveBridge,
  setBridgeName,
  setGigOptions,
  storeFeatureFlagState,
  setFeatureFlagsState,
  setAvailableFeaturesOnSetup,
  setPresenterTracks,
  setRoom,
  setWebcam
}
